import styled from "styled-components";
import { Props } from "./index";

const MultimidiasContainer = styled.div<Props>``;
export { MultimidiasContainer };
